import React from 'react';

function OrderConfirmationModal({
  book,
  format,
  language,
  digitalType,
  quantity,
  price,
  email,
  commune,
  wilaya,
  bundleCovers,
  onClose,
}) {
  const themeClass =
    book.id === 'inbetween' ? 'theme-inbetween' : book.id === 'bundle' ? 'theme-bundle' : 'theme-bwgo';

  return (
    <div
      className="confirm-overlay"
      onClick={(e) => { if (e.target.classList.contains('confirm-overlay')) onClose(); }}
    >
      <div className={`confirm-modal ${themeClass}`}>
        <button className="confirm-close-icon" onClick={onClose} aria-label="Close">✕</button>
        <div className="confirm-bar" />
        <div className="confirm-cover-wrap">
          {book.isBundle ? (
            <div className="confirm-covers-bundle">
              <img
                src={format === 'digital' ? bundleCovers.digital[0] : bundleCovers.paper[0]}
                alt="Book 1"
                className="confirm-cover"
              />
              <img
                src={format === 'digital' ? bundleCovers.digital[1] : bundleCovers.paper[1]}
                alt="Book 2"
                className="confirm-cover"
              />
            </div>
          ) : (
            <img
              src={
                format === 'digital'
                  ? (language === 'ar' && book.arabicDigitalCover ? book.arabicDigitalCover : book.digitalCover)
                  : book.paperFront
              }
              alt={book.title}
              className="confirm-cover"
            />
          )}
        </div>
        <div className="confirm-body">
          <h2 className="confirm-title">
            {format === 'digital' ? 'Check your inbox!' : 'On its way to you!'}
          </h2>
          <p className="confirm-book-title">
            {book.displayTitle || book.title}
            {language === 'ar' && ' (النسخة العربية)'}
            {' · '}
            {format === 'digital' ? digitalType.toUpperCase() : `×${quantity}`}
            {' · '}
            {price} DA
          </p>
          <div className="confirm-steps">
            {format === 'digital' ? (
              <>
                <div className="confirm-step">
                  <span className="step-num">1</span>
                  <div><strong>Payment verified</strong><p>We'll check your proof within a few hours.</p></div>
                </div>
                <div className="confirm-step">
                  <span className="step-num">2</span>
                  <div><strong>Book sent to {email || 'your email'}</strong><p>Check inbox & spam folder.</p></div>
                </div>
              </>
            ) : (
              <>
                <div className="confirm-step">
                  <span className="step-num">1</span>
                  <div><strong>Payment verified</strong><p>We'll confirm your proof within a few hours.</p></div>
                </div>
                <div className="confirm-step">
                  <span className="step-num">2</span>
                  <div><strong>Packed with care</strong><p>Your order is prepared and handed to delivery.</p></div>
                </div>
                <div className="confirm-step">
                  <span className="step-num">3</span>
                  <div><strong>Delivered in 2–3 days</strong><p>To {commune ? `${commune}, ` : ''}{wilaya || 'your address'}.</p></div>
                </div>
              </>
            )}
          </div>
          <p className="confirm-help">
            {format === 'digital' ? "Didn't get it within 24h? " : 'Need help with your order? '}
            <a href="https://wa.me/213654683600" target="_blank" rel="noreferrer" className="confirm-whatsapp">
              Message us on WhatsApp →
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default OrderConfirmationModal;